import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {useAuth} from '../../modules/auth'
import {AdminDashboardPage} from './AdminDashboardPage'
import {FinanceDashboardPage} from './FinanceDashboardPage'
import {ManagerDashboardPage} from './ManagerDashboardPage'
import {SupervisorDashboardPage} from './SupervisorDashboardPage'

const DashboardPage = () => {
  const {currentUser} = useAuth()
  const dashboardType = currentUser?.dashboardType || 'NO_DASHBOARD'

  // Render the appropriate dashboard based on user's dashboard type
  const renderDashboard = () => {
    switch (dashboardType) {
      case 'NO_DASHBOARD':
        return (
          <div className="card">
            <div className="card-body text-center py-20">
              <i className="bi bi-speedometer2 fs-3x text-muted mb-5"></i>
              <h3 className="text-gray-800 mb-3">No Dashboard Assigned</h3>
              <p className="text-muted fs-5">
                Please contact your administrator to assign a dashboard for your account.
              </p>
            </div>
          </div>
        )
      case 'ADMIN_DASHBOARD':
        return <AdminDashboardPage />
      case 'FINANCE_DASHBOARD':
        return <FinanceDashboardPage />
      case 'MANAGER_DASHBOARD':
        return <ManagerDashboardPage />
      case 'SUPERVISOR_DASHBOARD':
        return <SupervisorDashboardPage />
      default:
        return <AdminDashboardPage />
    }
  }

  return <>{renderDashboard()}</>
}

const DashboardWrapper = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Dashboard</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
